import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.58333 9.54991L10.9833 5.16657C11.1056 5.04435 11.2444 4.98602 11.4 4.99157C11.5556 4.99713 11.6944 5.06102 11.8167 5.18324C11.9389 5.30546 12 5.44435 12 5.59991C12 5.75546 11.9389 5.89435 11.8167 6.01657L7.01667 10.8166C6.89444 10.9388 6.75278 10.9999 6.59167 10.9999C6.43056 10.9999 6.28889 10.9388 6.16667 10.8166L4.18333 8.83324C4.06111 8.71102 4 8.57213 4 8.41657C4 8.26102 4.06111 8.12213 4.18333 7.99991C4.30556 7.87768 4.44444 7.81657 4.6 7.81657C4.75556 7.81657 4.89444 7.87768 5.01667 7.99991L6.58333 9.54991Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }